import { useLocation } from 'react-router-dom'

import { SECTION_NAMES } from '@constants/sectionNames'

import { createReportLink } from '../utils/createReportLink'

type UseReportLinkParams = {
  reportId: string
  filters?: Record<string, string>
}

export const useReportLink = ({ reportId, filters }: UseReportLinkParams) => {
  const location = useLocation()
  const baseLink = createReportLink({ label: SECTION_NAMES.analytics, location })(reportId)

  if (!filters || Object.keys(filters).length === 0) return baseLink

  const params = new URLSearchParams(location.search)
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).length > 0) {
      params.set(key, String(value))
    } else {
      params.delete(key)
    }
  })

  return {
    ...baseLink,
    to: {
      ...baseLink.to,
      search: params.toString() ? `?${params.toString()}` : '',
    },
  }
}
